'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fSelect$002ejs from "@ui5/webcomponents/dist/Select.js";
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp from "./com.raquo.laminar.keys.-Event-Prop.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.Il = null;
  this.Im = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-select");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$.prototype = $p;
$p.jt = (function() {
  if ((!this.Im)) {
    this.Il = new $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp.$c_Lcom_raquo_laminar_keys_EventProp("change");
    this.Im = true;
  }
  return this.Il;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fSelect$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$, "io.github.nguyenyou.ui5.webcomponents.laminar.Select$", ({
  jJ: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Select$ };
